<mat-card class="question-card center">
  <mat-card-content>
    <mat-label class="mat-title question-text">{{title}}</mat-label>
    <div *ngIf="text">
      <mat-expansion-panel>
        <mat-expansion-panel-header class="right-aligned-header">
          <mat-panel-title></mat-panel-title>
          <mat-panel-description>
            {{toggleText}}
          </mat-panel-description>         
        </mat-expansion-panel-header>       
        <p>{{text}}</p>       
      </mat-expansion-panel>
    </div>
    <div class="clearfix"></div>
    <div *ngIf="ctrl">
      <mat-error *ngIf="invalid">
        <div *ngIf="ctrl.errors.required" [innerHTML]="requiredErrorMessage"></div>
        <div *ngIf="!ctrl.errors.required && !ctrl.errors.pattern && ctrl.errors.minlength" [innerHTML]="minLengthErrorMessage"></div>
        <div *ngIf="!ctrl.errors.required && !ctrl.errors.pattern && ctrl.errors.maxlength" [innerHTML]="maxLengthErrorMessage"></div>
        <div *ngIf="!ctrl.errors.required && ctrl.errors.pattern" [innerHTML]="patternErrorMessage"></div>
      </mat-error>
    </div>
    <div [formGroup]="form">
      <div class="form-control">
        <mat-form-field *ngIf="ctrl"  floatLabel="never">
          <textarea matInput placeholder="{{question.name}}" cdkTextareaAutosize #autosize="cdkTextareaAutosize" [ngClass]="{'no-scroll': question.validators.maxLength <= 100}" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" id="{{question.name}}" [formControl]="ctrl"></textarea>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
